import React__default from 'react';
import { TooltipWrapper } from '../../display/TooltipWrapper/TooltipWrapper.es.js';
import { Spinner } from '../../display/Spinner/Spinner.es.js';

const root = "_root_y4rnp_1";
const innerWrap = "_inner-wrap_y4rnp_48";
const input = "_input_y4rnp_56";
const spinner = "_spinner_y4rnp_69";
const dot = "_dot_y4rnp_82";
const styles = {
	root: root,
	innerWrap: innerWrap,
	input: input,
	spinner: spinner,
	dot: dot
};

const getAriaLabel = (props) => {
  if (props["aria-label"]) {
    return props["aria-label"];
  }
  if (props.isLoading) {
    return "Loading";
  }
  return props.checked ? "On" : "Off";
};
const getTooltipContent = (props) => props.disabled && props.showDisabledTooltip ? "Disabled" : "";
const ToggleSwitch = ({ "aria-label": ariaLabel = void 0, checked = void 0, disabled = void 0, id = void 0, isLoading = false, name = void 0, onChange = () => {
}, showDisabledTooltip = true, value = void 0 }) => {
  const props = {
    "aria-label": ariaLabel,
    checked,
    disabled,
    id,
    isLoading,
    name,
    onChange,
    showDisabledTooltip,
    value
  };
  return React__default.createElement(TooltipWrapper, { content: getTooltipContent(props) }, ({ childProps }) => React__default.createElement(
    "label",
    Object.assign({}, childProps, { className: styles.root, "data-checked": props.checked || void 0, "data-disabled": props.disabled || void 0, "data-loading": props.isLoading || void 0, "data-zds": true }),
    React__default.createElement(
      "span",
      { className: styles.innerWrap, "data-zds": true },
      React__default.createElement("input", { "aria-disabled": props.disabled || props.isLoading, "aria-label": getAriaLabel(props), checked: props.checked, className: styles.input, disabled: props.disabled || props.isLoading, "data-zds": true, id: props.id, name: props.name, onChange: props.onChange, type: "checkbox", value: props.value }),
      props.isLoading && React__default.createElement(
        "span",
        { className: styles.spinner, "data-zds": true },
        React__default.createElement(Spinner, null)
      ),
      !props.isLoading && React__default.createElement("span", { "aria-hidden": "true", className: styles.dot, role: "presentation", "data-zds": true })
    )
  ));
};

export { ToggleSwitch };
//# sourceMappingURL=ToggleSwitch.es.js.map
